const state = {
  productCategories: [],
  isLoadingProductCategories: true
};

const getters = {
  filterableProductCategories(
    { productCategories },
    _getters,
    { widget: { widget } }
  ) {
    let filterableProductCategories = productCategories.filter(
      c => c.depth === widget.filterable_category_depth
    );
    if (widget.category_id)
      filterableProductCategories = filterableProductCategories.filter(
        c => c.parent_category_id === widget.category_id
      );
    return filterableProductCategories;
  }
};

const mutations = {
  SET_PRODUCT_CATEGORIES(state, productCategories) {
    state.productCategories = productCategories;
  },
  SET_IS_LOADING_PRODUCT_CATEGORIES(state, isLoadingProductCategories) {
    state.isLoadingProductCategories = isLoadingProductCategories;
  }
};

const actions = {
  fetchProductCategories({ commit, rootState }) {
    const product_code = rootState.productCode;
    const widget_id = rootState.widget.widget.id;
    commit('SET_IS_LOADING_PRODUCT_CATEGORIES', true);
    rootState.api
      .fetchProductCategories(product_code, widget_id)
      .then(({ data }) => {
        commit('SET_PRODUCT_CATEGORIES', data.categories);
      })
      .finally(() => commit('SET_IS_LOADING_PRODUCT_CATEGORIES', false));
  }
};

export default { namespaced: true, state, getters, mutations, actions };
